import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EventsComponent } from './events/events.component';
import { EventTypeComponent } from './event-type/event-type.component';
import { ReportComponent } from './report/report.component';
import { UserComponent } from './user/user.component';
import { LoginComponent } from './login/login.component';
import { AdminComponent } from './admin/admin.component';
import { ListingComponent } from './listing/listing.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddeventComponent } from './events/addevent/addevent.component';
import { EditeventComponent } from './events/editevent/editevent.component';
import { SettingComponent } from './setting/setting.component';
import { AdminUserComponent } from './admin-user/admin-user.component';
import { CardDesignComponent } from './card-design/card-design.component';
import { AddlistingComponent } from './listing/addlisting/addlisting.component';
import { EditlistingComponent } from './listing/editlisting/editlisting.component';
import { RegistrationComponent } from './registration/registration.component';
import { RsvpComponent } from './rsvp/rsvp.component';
import { RegistrationSettingComponent } from './registration-setting/registration-setting.component';
import { RegistrationListComponent } from './registration-list/registration-list.component';
import { EventUserComponent } from './event-user/event-user.component';
import { AuthGuard } from 'src/guard/auth.guard';
import { Card1Component } from './card-design/card1/card1.component';
import { Card2Component } from './card-design/card2/card2.component';
import { Card3Component } from './card-design/card3/card3.component';
import { ScanningPointComponent } from './scanning-point/scanning-point.component';
import { AppRegistrationSettingComponent } from './app-registration-setting/app-registration-setting.component';
import { AppCardDesignComponent } from './app-card-design/app-card-design.component';
import { AppAddEventComponent } from './app-add-event/app-add-event.component';
import { Idcard1Component } from './idcard1/idcard1.component';
import { Idcard2Component } from './idcard2/idcard2.component';
import { Idcard3Component } from './idcard3/idcard3.component';
import { CustomCardComponent } from './custom-card/custom-card.component';
import { PaymentComponent } from './payment/payment.component';
import { SuccessComponent } from './success/success.component';
import { PaymentSettingComponent } from './payment-setting/payment-setting.component';
import { AdvertiseComponent } from './advertise/advertise.component';
import { CouponCodeComponent } from './coupon-code/coupon-code.component';
import { AppPaymentSettingComponent } from './app-payment-setting/app-payment-setting.component';
import { AppCustomCardComponent } from './app-custom-card/app-custom-card.component';
import { PushNotificationComponent } from './push-notification/push-notification.component';
import { TicketCategoryComponent } from './ticket-category/ticket-category.component';
import { TicketsComponent } from './tickets/tickets.component';
import { AddTicketCategoryComponent } from './ticket-category/add-ticket-category/add-ticket-category.component';
import { StallComponent } from './stall/stall.component';
import { MystallComponent } from './mystall/mystall.component';
import { StallScanComponent } from './mystall/stall-scan/stall-scan.component';
import { StallProductComponent } from './stall-product/stall-product.component';
import { StallCategoryComponent } from './stall-category/stall-category.component';
import { EditStallComponent } from './mystall/edit-stall/edit-stall.component';
import { GalleryComponent } from './gallery/gallery.component';
import { EditgalleryComponent } from './gallery/editgallery/editgallery.component';
import { CatalogueInquiryComponent } from './catalogue-inquiry/catalogue-inquiry.component';
import { MycatalogueComponent } from './mycatalogue/mycatalogue.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { AppAddTicketCategoryComponent } from './app-add-ticket-category/app-add-ticket-category.component';
import { EditTicketCategoryComponent } from './ticket-category/edit-ticket-category/edit-ticket-category.component';
import { BlankPageComponent } from './blank-page/blank-page.component';
import { AppEditTicketCategoryComponent } from './app-edit-ticket-category/app-edit-ticket-category.component';
import { ArtistsComponent } from './artists/artists.component';
import { SponsorComponent } from './sponsor/sponsor.component';
import { StallFormComponent } from './stall-form/stall-form.component';
import { CreateEventStallComponent } from './mystall/create-event-stall/create-event-stall.component';
import { AppArtistsComponent } from './app-artists/app-artists.component';
import { AppSponsorComponent } from './app-sponsor/app-sponsor.component';
import { AppCreateEventStallComponent } from './app-create-event-stall/app-create-event-stall.component';
import { StallCataloguesListComponent } from './stall-catalogues-list/stall-catalogues-list.component';
import { SoEventDetailComponent } from './so-event-detail/so-event-detail.component';
import { RegistrationEditComponent } from './registration-edit/registration-edit.component';
import { SuccessRegistrationComponent } from './registration/success-registration/success-registration.component';
import { ProductQrComponent, ProductQrClaimComponent } from './product-qr/product-qr.component';
import { StallUersComponent } from './mystall/stall-uers/stall-uers.component';
import { RedeemrequestsComponent } from './redeemrequests/redeemrequests.component';
import { ViewServicesComponent } from './view-services/view-services.component';
import { ViewServiceDetailComponent } from './view-services/view-service-detail/view-service-detail.component';
import { BlogComponent } from './blog/blog.component';

const routes: Routes = [
  { path: '', component: BlankPageComponent },


  { path: 'admin-auth', component: LoginComponent },
  /**
   * ========= ADMIN / WEB ROUTES =========
   */

  {
    path: 'admin',
    component: AdminComponent,
    children: [
      { path: 'Events', canActivate: [AuthGuard], component: EventsComponent },
      { path: 'Events/AddEvent', canActivate: [AuthGuard], component: AddeventComponent },
      { path: 'Events/EditEvent', canActivate: [AuthGuard], component: EditeventComponent },
      { path: 'Event Type', canActivate: [AuthGuard], component: EventTypeComponent },
      { path: 'stallCatalogues', canActivate: [AuthGuard], component: StallCataloguesListComponent },
      { path: 'Reports', canActivate: [AuthGuard], component: ReportComponent },
      { path: 'Transactions', canActivate: [AuthGuard], component: TransactionsComponent },
      { path: 'Users', canActivate: [AuthGuard], component: UserComponent },
      { path: 'Listings', canActivate: [AuthGuard], component: ListingComponent },
      { path: 'Listings/AddListings', canActivate: [AuthGuard], component: AddlistingComponent },
      { path: 'Listings/EditListings', canActivate: [AuthGuard], component: EditlistingComponent },
      { path: 'Dashboard', canActivate: [AuthGuard], component: DashboardComponent },
      { path: 'Setting', canActivate: [AuthGuard], component: SettingComponent },
      { path: 'AdminUser', canActivate: [AuthGuard], component: AdminUserComponent },
      { path: 'Registration Setting', canActivate: [AuthGuard], component: RegistrationSettingComponent },
      { path: 'Card Design', canActivate: [AuthGuard], component: CardDesignComponent },
      { path: 'Card Design/Card1', canActivate: [AuthGuard], component: Card1Component },
      { path: 'Card Design/Card2', canActivate: [AuthGuard], component: Card2Component },
      { path: 'Card Design/Card3', canActivate: [AuthGuard], component: Card3Component },
      { path: 'Registered Users', canActivate: [AuthGuard], component: RegistrationListComponent },
      { path: 'Event Users', canActivate: [AuthGuard], component: EventUserComponent },
      { path: 'Scanning Points', canActivate: [AuthGuard], component: ScanningPointComponent },
      { path: 'Custom Card', canActivate: [AuthGuard], component: CustomCardComponent },
      { path: 'Artists', canActivate: [AuthGuard], component: ArtistsComponent },
      { path: 'Sponsor', canActivate: [AuthGuard], component: SponsorComponent },
      { path: 'Payment Setting', canActivate: [AuthGuard], component: PaymentSettingComponent },
      { path: 'Coupon Code', canActivate: [AuthGuard], component: CouponCodeComponent },
      { path: 'Advertise', canActivate: [AuthGuard], component: AdvertiseComponent },
      { path: 'Push Notification', canActivate: [AuthGuard], component: PushNotificationComponent },
      { path: 'Ticket Category', canActivate: [AuthGuard], component: TicketCategoryComponent },
      { path: 'Tickets', canActivate: [AuthGuard], component: TicketsComponent },
      { path: 'Add Tickets Category', canActivate: [AuthGuard], component: AddTicketCategoryComponent },
      { path: 'Edit Tickets Category', canActivate: [AuthGuard], component: EditTicketCategoryComponent },
      { path: 'Stall', canActivate: [AuthGuard], component: StallComponent },
      { path: 'My Stall', canActivate: [AuthGuard], component: MystallComponent },
      { path: 'My Catalogue', canActivate: [AuthGuard], component: MycatalogueComponent },
      { path: 'catinquiry/:so_id', canActivate: [AuthGuard], component: CatalogueInquiryComponent },
      { path: 'Stall Scan/:so_id', canActivate: [AuthGuard], component: StallScanComponent },
      { path: 'Blog', canActivate: [AuthGuard], component: BlogComponent },

      /** Web Admin Routes with AuthGuard */
      { path: 'Edit Stall/:so_id', canActivate: [AuthGuard], component: EditStallComponent },
      { path: 'Products/:so_id', canActivate: [AuthGuard], component: StallProductComponent },
      { path: 'Category/:so_id', canActivate: [AuthGuard], component: StallCategoryComponent },

      { path: 'Gallery', canActivate: [AuthGuard], component: GalleryComponent },
      { path: 'EditGallery', canActivate: [AuthGuard], component: EditgalleryComponent },
      { path: 'My Stall/CreateEventStall', canActivate: [AuthGuard], component: CreateEventStallComponent },
      { path: 'SoEventDetail', canActivate: [AuthGuard], component: SoEventDetailComponent },
      { path: 'Product QR/:so_id', canActivate: [AuthGuard], component: ProductQrComponent },
      { path: 'stallsusers/:so_id', component: StallUersComponent },
      { path: 'redeemrequests/:so_id', component: RedeemrequestsComponent }
    ]
  },

  /**
   * ========= MOBILE / PUBLIC ROUTES =========
   * These are OUTSIDE of Admin and don't use AuthGuard
   */
  { path: 'Registration/:event_id', component: RegistrationComponent, title: 'Registration Form' },
  { path: 'Registration/:event_id/:refercode', component: RegistrationComponent, title: 'Registration Form' },
  { path: 'Registration/:event_id/:refercode/:created_by', component: RegistrationComponent, title: 'Registration Form' },
  { path: 'registration-success', component: SuccessRegistrationComponent, title: 'Registration Success' },

  { path: 'RegistrationEdit/:event_id/:mem_id/:reg_id/:user_id', component: RegistrationEditComponent, title: 'Edit Registration' },
  { path: 'rsvp/:event_id', component: RsvpComponent, title: 'RSVP Form' },

  { path: 'AppRegistrationSetting', component: AppRegistrationSettingComponent },
  { path: 'AppCardDesign', component: AppCardDesignComponent },
  { path: 'AppAddEvent', component: AppAddEventComponent },
  { path: 'idcard1/:event_id/:mem_id', component: Idcard1Component },
  { path: 'idcard2/:event_id/:mem_id', component: Idcard2Component },
  { path: 'idcard3/:event_id', component: Idcard3Component },
  { path: 'Payment', component: PaymentComponent },
  { path: 'Success/:event_id/:pid', component: SuccessComponent },
  { path: 'AppPaymentSetting', component: AppPaymentSettingComponent },
  { path: 'AppCustomCard', component: AppCustomCardComponent },
  { path: 'AppGallery/:event_id', component: GalleryComponent },
  { path: 'AppEditGallery/:event_id', component: EditgalleryComponent },
  { path: 'AppAddTicketCategory', component: AppAddTicketCategoryComponent },
  { path: 'AppEditTicketCategory', component: AppEditTicketCategoryComponent },
  { path: 'StallForm/:so_id', component: StallFormComponent },
  { path: 'AppArtist', component: AppArtistsComponent },
  { path: 'AppSponsor', component: AppSponsorComponent },
  { path: 'CreateEventStall/:user_id', component: AppCreateEventStallComponent },
  { path: 'ProductQrClaim/:uid', component: ProductQrClaimComponent },
  { path: 'ViewServices/:id', component: ViewServicesComponent },
  { path: 'ViewServicesDetail/:id', component: ViewServiceDetailComponent },

  /** Mobile Routes - No AuthGuard */
  { path: 'm/Edit Stall/:so_id', component: EditStallComponent },
  { path: 'm/Products/:so_id', component: StallProductComponent },
  { path: 'm/Category/:so_id', component: StallCategoryComponent },
  { path: '**', component: BlankPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

